<template>
  <pt-holiday-manage class="pt-holiday-manage__page" ref="page"></pt-holiday-manage>
</template>

<script>
import PtHolidayManage from 'cps/lab-order/pt-holiday-manage/withData'
export default {
  name: 'pt-holiday-manage__view',
  components: {
    'pt-holiday-manage': PtHolidayManage
  },
  watch: {
    '$route.meta.type' (val, old) {
      if (val !== old) {
        this.$refs.page && this.$refs.page.load()
      }
    }
  }
}
</script>
